import { useSnackbar } from "notistack";
import { EditBase, useEditContext } from "ra-core";
import React, { FC, useCallback } from "react";
import OrganizationProfileForm from "~/components/settings/OrganizationProfileForm";
import { SaveAction } from "~/dataProvider/types";
import { OrganizationProfileInput } from "~/gen/api/user";
import { OdResourcePageProps } from "~/types/resource";


export const OrganizationProfileUpdateCater: FC<OdResourcePageProps> = (props) => {
  const { save, record } = useEditContext<OrganizationProfileInput & { id: string }>({ redirect: '/dashboard' })
  const { enqueueSnackbar } = useSnackbar()

  const performSave = useCallback<SaveAction<OrganizationProfileInput>>((record, redirect, callbacks) => {
    const fn = save || (() => {})

    const onSuccess = (resp: any) => 
      Promise.resolve(callbacks && callbacks.onSuccess && callbacks.onSuccess(resp))
        .then(() => enqueueSnackbar('Update succeed', { variant: 'success' }))
    const onFailure = (err: any) => 
      Promise.resolve(callbacks && callbacks.onFailure && callbacks.onFailure(err))
        .then(() => enqueueSnackbar('Update failed', { variant: 'error' }))

    fn(record, redirect, { ...callbacks, onSuccess, onFailure })
  }, [save, enqueueSnackbar])

  return (
    <OrganizationProfileForm save={performSave} record={record} {...props} />
  )
}

const OrganizationProfileUpdate: FC<OdResourcePageProps> = (props) => {
  return (
    <EditBase {...props} mutationMode={'pessimistic'} >
      <OrganizationProfileUpdateCater {...props} />
    </EditBase>
  )
}

export default OrganizationProfileUpdate;
